import React, { useContext, useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { getImages } from './const';
import { VehicleContext } from '../Context/VehicleContext';

const Header = () => {
    const location = useLocation();
    // const isHomePage = location.pathname === '/' || location.pathname === '/team-mark-motors-in-boerne-tx' || location.pathname === '/contact-mark-motors-in-boerne-tx';
    // const isHomePage = location.pathname === '/' || location.pathname === '/our-team' || location.pathname === '/contact';
    const [isMob, setisMob] = useState(false);

    const {vehicleData, currentFilterData} = useContext(VehicleContext);

    const onChangeBodyClass = (value) => {
        setisMob(value);
        value
            ? document.body.classList.add('overflow-active')
            : document.body.removeAttribute('class');
    };
    const [openSubMenu,  setOpenSubMenu] = useState(null)
    const handleSubMenu = (menuName) => {
        setOpenSubMenu(prev => (prev === menuName ? null : menuName));
    };
    const closeMenu = () => {
        setisMob(false); 
        setOpenSubMenu(false);
        document.body.classList.remove('overflow-active');
    }

    const [inventoryMenuList,setInventoryMenuList] = useState([]);
    // console.log("inventoryMenuList", inventoryMenuList)
    useEffect(() => {
        const makeCounts = currentFilterData.make.map((v,i) => {
            return {
                title: v.name,
                count: v.available,
            }
        });

        setInventoryMenuList(makeCounts);
    },[vehicleData]);
    const countTotal = inventoryMenuList?.reduce((sum, brand) => sum + brand.count, 0);
  return (
    <>
        <header className={`header-wrap `}>
            <div className="container mxw-1366">
                <div className="header-block d-flex align-items-center justify-content-between">
                    <div className="header-left">
                        <Link to="/" className="main-logo d-block">
                            <img src={getImages('mm-logo-white.svg')} alt='logo' />
                        </Link>
                    </div>
                    <div className="header-right d-flex align-items-center justify-content-between">
                        <div className={`d-flex w-100 align-items-center justify-content-between menu-block ${isMob ? 'active' : ''}`}>
                            <div className="main-menu">
                                <ul>
                                    <li>
                                        <NavLink to="/" onClick={closeMenu}>Home</NavLink>
                                    </li>
                                    <li className={`sub-menu ${openSubMenu === 'inventory' ? 'open' : ''}`}>
                                        <NavLink to="/cars-for-sale-boerne-tx" className='for-desktop'>Inventory <span className='menu-arrow-icon'></span></NavLink>
                                        <a href="#" className='for-mobile' onClick={() => handleSubMenu('inventory')}>Inventory <span className='menu-arrow-icon'></span></a>
                                        <ul className='sub-mega-menu service-m-menu'>
                                            <li className='w-100'>
                                                <div className='row'>
                                                    <div className='col-md-4 my-2'>
                                                        <a href={'/cars-for-sale-boerne-tx'} onClick={closeMenu} className='subm-col d-flex align-items-center justify-content-between'>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='mm-search-icon me-3 mb-0'>
                                                                    <img src={getImages('icon-search.png')}/>
                                                                </div>
                                                                <div className='xs-title text-white'>View All</div>
                                                            </div>
                                                            <div className='subm-circle'>{countTotal}</div>
                                                        </a>
                                                    </div>
                                                    {inventoryMenuList.map((item, index)=>
                                                        <div className='col-md-4 my-2' key={index}>
                                                            <a href={'/cars-for-sale-boerne-tx?make=' + item.title} onClick={closeMenu} className='subm-col d-flex align-items-center justify-content-between'>
                                                                <div className='d-flex align-items-center'>
                                                                    <div className='subm-icon me-4'>
                                                                        <img src={getImages(`logos/${item.title}.png`)} alt={item.title}/>
                                                                    </div>
                                                                    <div className='xs-title'>{item.title}</div>
                                                                </div>
                                                                <div className='subm-circle'>{item.count}</div>
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <NavLink to="/trade-or-sell-exotic-car" onClick={closeMenu}>Sell My Exotic</NavLink>
                                    </li>
                                    <li className={`sub-menu position-relative ${openSubMenu === 'finance' ? 'open' : ''}`}>
                                        <NavLink to="/financing" className='for-desktop'>Finance <span className='menu-arrow-icon'></span></NavLink>
                                        <a href="#" className='for-mobile' onClick={() => handleSubMenu('finance')}>Finance <span className='menu-arrow-icon'></span></a>
                                        <ul className='sub-menu-box'>
                                            <li className='w-100'>
                                                <NavLink to="/financing" onClick={closeMenu}>Finance</NavLink>
                                            </li>
                                            <li className='w-100'>
                                                <NavLink to="/applyforcredit-austin" onClick={closeMenu}>CREDIT APPLICATION - AUSTIN</NavLink>
                                            </li>
                                            <li className='w-100'>
                                                <NavLink to="/applyforcredit-boerne" onClick={closeMenu}>CREDIT APPLICATION - BOERNE</NavLink>
                                            </li>
                                            <li className='w-100'>
                                                <NavLink to='/trade-or-sell-exotic-car' onClick={closeMenu}>Trade In</NavLink>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className={`sub-menu position-relative ${openSubMenu === 'services' ? 'open' : ''}`}>
                                        <NavLink to="/schedule-car-maintenance-or-auto-repair-boerne-tx" className='for-desktop'>Services <span className='menu-arrow-icon'></span></NavLink>
                                        <a href="#" className='for-mobile' onClick={() => handleSubMenu('services')}>Services <span className='menu-arrow-icon'></span></a>
                                        <ul className='sub-menu-box'>
                                            <li className='w-100'>
                                                <NavLink to='/schedule-car-maintenance-or-auto-repair-boerne-tx' onClick={closeMenu}>Service Center</NavLink>
                                            </li>
                                            {/* <li className='w-100'>
                                                <NavLink to='https://markcustoms.com/' target='_blank' onClick={closeMenu}>Mark Customs</NavLink>
                                            </li> */}
                                            {/*<li className='w-100'>
                                                 <NavLink to='/detailing'>Mark Motors Detailing</NavLink> 
                                                <NavLink to='https://markmotorsdetailing.com/' target='_blank' onClick={closeMenu}>Mark Motors Detailing</NavLink>
                                            </li>*/}
                                        </ul>
                                    </li>
                                    <li className={`sub-menu position-relative ${openSubMenu === 'aboutus' ? 'open' : ''}`}>
                                        <NavLink to="/contact-mark-motors-in-boerne-tx" className='for-desktop'>About Us <span className='menu-arrow-icon'></span></NavLink>
                                        <a href="#" className='for-mobile' onClick={() => handleSubMenu('aboutus')}>About Us <span className='menu-arrow-icon'></span></a>
                                        <ul className='sub-menu-box'>
                                            <li className='w-100'>
                                                <NavLink to='/team-mark-motors-in-boerne-tx' onClick={closeMenu}>Our Team</NavLink>
                                            </li>
                                            <li className='w-100'>
                                                <NavLink to='/who-is-mark' onClick={closeMenu}>Who is Mark?</NavLink>
                                            </li>
                                            <li className='w-100'>
                                                <NavLink to='/mark-motors-dealership-customer-reviews' onClick={closeMenu}>Testimonials</NavLink>
                                            </li>
                                            <li className='w-100'>
                                                <NavLink to='/contact-mark-motors-in-boerne-tx' onClick={closeMenu}>Contact Us</NavLink>
                                            </li>
                                        </ul>
                                    </li>
                                    {/* <li className={`sub-menu ${openSubMenu === 'service' ? 'open' : ''}`}>
                                        <NavLink to="/" onClick={closeMenu} className="d-none d-lg-block">Service <span className='menu-arrow-icon'></span></NavLink>
                                        <a href="#" onClick={() => handleSubMenu('service')} className='d-lg-none'>Service <span className='menu-arrow-icon'></span></a>
                                        <ul className='sub-mega-menu service-m-menu'>
                                            <li className='w-100'>
                                                <div className='d-flex justify-content-between'>
                                                    <div className='smm-col'>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='d-none d-lg-block md-title text-white ps-3 fw-400'>Service</div>
                                                            <NavLink to="/" onClick={closeMenu} className="d-lg-none md-title fw-400 text-white">Service</NavLink>
                                                        </div>
                                                        <ul className='inside-menu'>
                                                            <li>
                                                                <Link to='/' onClick={closeMenu}>Service 1</Link>
                                                            </li>
                                                            <li>
                                                                <Link to="/" onClick={closeMenu}>Service 2</Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </li> */}
                                    <li>
                                        {/* <NavLink to="/" onClick={closeMenu}>Financing</NavLink> */}
                                    </li>
                                    {/* <li>
                                        <NavLink to="/" onClick={closeMenu}>Contact Us</NavLink>
                                    </li> */}
                                </ul>
                            </div>
                            <div className='ms-3'>
                                <Link to="/contact-mark-motors-in-boerne-tx" onClick={closeMenu} className='btn-black-theme d-inline-block'>Contact Us</Link>
                            </div>
                        </div>
                        <div className={`overflow-bg ${isMob ? 'active' : ''
                            }`} onClick={() => onChangeBodyClass(!isMob)}></div>
                        <div
                            className={`mobile-inner-header ${isMob ? 'active' : ''}`}
                            onClick={() => onChangeBodyClass(!isMob)}
                        >
                            <div
                                className={`mobile-inner-header-icon mobile-inner-header-icon-out ${isMob ? 'active' : ''
                                    }`}
                            >
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    </>
  )
}

export default Header